import axios from "axios";
import { getCookie } from "../helpers/cookie";

const token = getCookie("_token");

const instance = axios.create({
  // baseURL: "http://localhost:9009"
  baseURL: "https://app.traxon.uz"
});

if (token) {
  instance.defaults.headers.common = { Authorization: `Bearer ${token}` };
}
export default instance;

